import { atom, useAtom } from '@/core/features/store/atom-store';

const wishlistItemsAtom = atom<Record<number, boolean>>({});
export const useWishlistSelectItemState = () => useAtom(wishlistItemsAtom);
